import * as actionTypes from './actionTypes';

export const toggleFinishModal=(collectionId)=>({
    type:actionTypes.TOGGLE_3D_FINISH_MODAL,
    payload:collectionId
})